export const russianCitiesEN = [
  {
    "label": "Maykop",
    "post_code": "385000"
  },
  {
    "label": "Gorno-Altaysk",
    "post_code": "649000"
  },
  {
    "label": "Ufa",
    "post_code": "450000"
  },
  {
    "label": "Ulan-Ude",
    "post_code": "670000"
  },
  {
    "label": "Makhachkala",
    "post_code": "367000"
  },
  {
    "label": "Magas",
    "post_code": "386000"
  },
  {
    "label": "Nalchik",
    "post_code": "360000"
  },
  {
    "label": "Elista",
    "post_code": "358000"
  },
  {
    "label": "Cherkessk",
    "post_code": "369000"
  },
  {
    "label": "Petrozavodsk",
    "post_code": "185000"
  },
  {
    "label": "Syktyvkar",
    "post_code": "167000"
  },
  {
    "label": "Yoshkar-Ola",
    "post_code": "424000"
  },
  {
    "label": "Saransk",
    "post_code": "430000"
  },
  {
    "label": "Yakutsk",
    "post_code": "677000"
  },
  {
    "label": "Vladikavkaz",
    "post_code": "362000"
  },
  {
    "label": "Kazan",
    "post_code": "420000"
  },
  {
    "label": "Kyzyl",
    "post_code": "667000"
  },
  {
    "label": "Izhevsk",
    "post_code": "426000"
  },
  {
    "label": "Abakan",
    "post_code": "655000"
  },
  {
    "label": "Grozny",
    "post_code": "364000"
  },
  {
    "label": "Cheboksary",
    "post_code": "428000"
  },
  {
    "label": "Barnaul",
    "post_code": "656000"
  },
  {
    "label": "Krasnodar",
    "post_code": "350000"
  },
  {
    "label": "Krasnoyarsk",
    "post_code": "660000"
  },
  {
    "label": "Vladivostok",
    "post_code": "690000"
  },
  {
    "label": "Stavropol",
    "post_code": "355000"
  },
  {
    "label": "Khabarovsk",
    "post_code": "680000"
  },
  {
    "label": "Blagoveshchensk",
    "post_code": "675000"
  },
  {
    "label": "Arkhangelsk",
    "post_code": "163000"
  },
  {
    "label": "Astrakhan",
    "post_code": "414000"
  },
  {
    "label": "Belgorod",
    "post_code": "308000"
  },
  {
    "label": "Bryansk",
    "post_code": "241000"
  },
  {
    "label": "Vladimir",
    "post_code": "600000"
  },
  {
    "label": "Волгоград",
    "post_code": "400000"
  },
  {
    "label": "Vologda",
    "post_code": "160000"
  },
  {
    "label": "Voronezh",
    "post_code": "394000"
  },
  {
    "label": "Ivanovo",
    "post_code": "153000"
  },
  {
    "label": "Irkutsk",
    "post_code": "664000"
  },
  {
    "label": "Kaliningrad",
    "post_code": "236001"
  },
  {
    "label": "Kaluga",
    "post_code": "248000"
  },
  {
    "label": "Petropavlovsk-Kamchatsky",
    "post_code": "683000"
  },
  {
    "label": "Kemerovo",
    "post_code": "650000"
  },
  {
    "label": "Киров",
    "post_code": "610000"
  },
  {
    "label": "Kostroma",
    "post_code": "156000"
  },
  {
    "label": "Kurgan",
    "post_code": "640000"
  },
  {
    "label": "Курск",
    "post_code": "305000"
  },
  {
    "label": "St.Petersburg",
    "post_code": "190000"
  },
  {
    "label": "Lipetsk",
    "post_code": "398000"
  },
  {
    "label": "Magadan",
    "post_code": "685000"
  },
  {
    "label": "Moscow",
    "post_code": "101000"
  },
  {
    "label": "Murmansk",
    "post_code": "183000"
  },
  {
    "label": "Nizhny-Novgorod",
    "post_code": "603000"
  },
  {
    "label": "Velikiy-Novgorod",
    "post_code": "173000"
  },
  {
    "label": "Novosibirsk",
    "post_code": "630000"
  },
  {
    "label": "Omsk",
    "post_code": "644000"
  },
  {
    "label": "Orenburg",
    "post_code": "460000"
  },
  {
    "label": "Orel",
    "post_code": "302000"
  },
  {
    "label": "Penza",
    "post_code": "440000"
  },
  {
    "label": "Permian",
    "post_code": "614000"
  },
  {
    "label": "Pskov",
    "post_code": "180000"
  },
  {
    "label": "Rostov-on-Don",
    "post_code": "344000"
  },
  {
    "label": "Ryazan",
    "post_code": "390000"
  },
  {
    "label": "Samara",
    "post_code": "443000"
  },
  {
    "label": "Saratov",
    "post_code": "410000"
  },
  {
    "label": "Yuzhno-Sakhalinsk",
    "post_code": "693000"
  },
  {
    "label": "Ekaterinburg",
    "post_code": "620000"
  },
  {
    "label": "Smolensk",
    "post_code": "214000"
  },
  {
    "label": "Tambov",
    "post_code": "392000"
  },
  {
    "label": "Tver",
    "post_code": "170000"
  },
  {
    "label": "Tomsk",
    "post_code": "634000"
  },
  {
    "label": "Tula",
    "post_code": "300000"
  },
  {
    "label": "Tyumen",
    "post_code": "625000"
  },
  {
    "label": "Ulyanovsk",
    "post_code": "432000"
  },
  {
    "label": "Chelyabinsk",
    "post_code": "454000"
  },
  {
    "label": "Chita",
    "post_code": "672000"
  },
  {
    "label": "Yaroslavl",
    "post_code": "150000"
  },
  {
    "label": "Obninsk",
    "post_code": "249030"
  }
];